<template>
  <div class="loading-page">
    <van-loading size="36px" vertical color="#07C160">
      {{ tipText }}
    </van-loading>
  </div>
</template>

<script>
import {
  findOrderJump
} from '@/api/api.js' // 沿用原有接口方法名
import {
  Toast
} from 'vant'

// ==========================================
// 🔧 业务类型枚举映射（与后端 Java 常量严格对齐）
// ==========================================
const MODULE_TYPE = {
  RECHARGE_WALLET_PAY: '7' // 扫码预存
}

export default {
  name: 'PayLoading',
  data () {
    return {
      tipText: '正在确认订单信息...'
    }
  },

  created () {
    const outTradeNo = this.$route.params.outTradeNo || this.$route.query.outTradeNo

    if (!outTradeNo) {
      Toast.fail('缺少订单号')
      return this.goTo('QueryRecharge')
    }

    this.dispatchRoute(outTradeNo)
  },

  methods: {
    async dispatchRoute (outTradeNo) {
      try {
        const response = await findOrderJump({
          outTradeNo
        })

        const bizData = response?.data
        const res = bizData?.extend?.data
        console.log(response)

        if (bizData?.code !== 0 || !res) {
          throw new Error(response?.msg || '接口返回异常')
        }

        const {
          moduleType,
          iccid
        } = res
        // 1. 扫码预存 -> 回首页
        if (moduleType === MODULE_TYPE.RECHARGE_WALLET_PAY) {
          return this.goTo('Home')
        }

        // 2. 剩余所有情况：有 iccid 去充值结果页，无 iccid 去查询页
        if (iccid) {
          return this.$router.push({
            name: 'MobileRecharge',
            params: {
              iccid: iccid
            }
          })
        } else {
          return this.goTo('QueryRecharge')
        }
      } catch (error) {
        console.error('[PayLoading] 获取业务类型失败:', error)
        this.tipText = '加载失败，正在跳转...'

        setTimeout(() => {
          this.goTo('QueryRecharge')
        }, 1500)
      }
    },

    // 统一跳转，使用 replace 避免返回键回到 Loading 页
    goTo (name, query = {}) {
      this.$router.replace({
        name,
        query
      })
    }
  }
}
</script>

<style scoped lang="less">
  .loading-page {
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #F7F8FA;
  }
</style>
